import React from 'react'
import { useRouteMatch } from 'react-router'

import CircleLeftIcon from '@SonarCX/components/icons/CircleLeftIcon'
import Link from './Link'

import { filterRoutes } from './helpers'
import useAccess from '@SonarCX/hooks/useAccess'
import { useResponsiveSettings } from '@SonarCX/providers/ResponsiveSettingsProvider'
import useUserPermissions from '@SonarCX/hooks/permissions/useUserPermissions'
import useStyles from './styles'

export const OPTIONS = {
  'Custom Fields': '/custom-fields',
  'External Channels': '/external-channels',
  General: '/general',
  Inboxes: '/inboxes',
  Integrations: '/integrations',
  Notifications: '/notifications',
  'Roles & Permissions': '/roles-permissions',
  'Subscription & Billing': '/subscription',
  Tags: '/tags',
  Tasks: '/tasks',
  Teams: '/teams',
  Users: '/users'
}

const SettingsOptions = () => {
  const { url } = useRouteMatch()

  const hasPermission = useAccess()
  const { isSmall, setSelecting } = useResponsiveSettings()
  const { hasAdmin } = useUserPermissions()

  const [open, setOpen] = React.useState(true)

  const visibleOptions = React.useMemo(
    () => filterRoutes(hasPermission, hasAdmin),
    [hasPermission, hasAdmin]
  )

  const classes = useStyles({ isSmall, open })

  const sorted = React.useMemo(() => {
    return Object.entries(visibleOptions).sort((a, b) => {
      const aVal = a[0]
      const bVal = b[0]
      return aVal.localeCompare(bVal)
    })
  }, [visibleOptions])

  return (
    <div className={classes.root}>
      {!isSmall && (
        <CircleLeftIcon
          onClick={() => setOpen(old => !old)}
          className={classes.arrowButton}
        />
      )}

      <div className={classes.titleArea}>
        <div className={classes.title}>Settings</div>
      </div>

      <div className={classes.options}>
        {sorted.map(([name, route]) => (
          <Link
            testid={`settings-link${route}`}
            key={route}
            to={`${url}${route}`}
            onClick={() => setSelecting(false)}
          >
            {name}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default SettingsOptions
